export default function here_query(url, map) {
  return new Promise(function(resolve, reject) {
    //default continental US
    if(map) {
      const bounds = map.getMaxBounds();
      let bbox='&in=bbox:'+bounds._sw.lng+','+bounds._sw.lat+','+bounds._ne.lng+','+bounds._ne.lat;
      url = url+bbox;
    }

    const request = new XMLHttpRequest();
    request.open('GET', url);
    request.responseType = 'json';
    request.onreadystatechange = function() {
      if (this.readyState === 4) {
        if (this.status === 200) {
          const results = request.response;
          resolve(results);
        } else {
          reject();
        }
      }
    };
    request.send();
  })
}

export function remove_html(line) {
  const regex = /(<[A-Za-z0-9/]*>)/g;
  return line.replace(regex, '\n');
}

export function here_search(searchText, map) {
  const geos = geo_search(searchText);
  const pois = poi_search(searchText, map);
  // const auto = auto_suggest(searchText, map);
  return [geos, pois /*auto*/];
}

export function geo_search(searchText, hereApiKey) {
  const url = 'https://geocode.search.hereapi.com/v1/geocode?apiKey=' +
    hereApiKey + '&maxresults=10&in=countryCode:USA&q='+searchText;
  return here_query(url)
}

export function poi_search(searchText, map, hereApiKey) {
  const url = 'https://discover.search.hereapi.com/v1/discover?apiKey=' +
    hereApiKey + '&limit=10&in=countryCode:USA&q='+searchText;
    return here_query(url, map);
}

export function auto_suggest(searchText, map, hereApiKey) {
  const url = 'https://places.sit.ls.hereapi.com/places/v1/autosuggest?apiKey=' +
    hereApiKey + '&size=10&addressFilter=countryCode=USA&q=' + searchText;
    return here_query(url, map);
}
